import { render, staticRenderFns } from "./MessageManager.vue?vue&type=template&id=37d3ade1&scoped=true"
import script from "./MessageManager.vue?vue&type=script&lang=js"
export * from "./MessageManager.vue?vue&type=script&lang=js"
import style0 from "./MessageManager.vue?vue&type=style&index=0&id=37d3ade1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d3ade1",
  null
  
)

export default component.exports